import React, { useEffect, useRef } from 'react'

const Signup = () => {
  const iframeRef = useRef(null);
  const logoUrl = `${window.location.origin}/express-logo.svg`;

  useEffect(() => {
    // Add message listener for iframe communication
    const handleMessage = (event) => {
      if (event.data && event.data.type === 'redirect') {
        // Open URL in new tab
        window.open(event.data.url, '_blank', 'noopener,noreferrer');
      }
    };

    window.addEventListener('message', handleMessage);

    // Create the HTML content with all dependencies
    const htmlContent = `
      <!DOCTYPE html>
      <html lang="en">
      <head>
          <meta charset="UTF-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <title>Newuser | Expressapp</title>
          <link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet" />
          <script src="https://unpkg.com/lucide@latest"></script>
      </head>

      <style>
          @media (min-width: 1024px) {
              h1 {
                  font-size: 48px;
              }
          }

          @media (min-width: 600px) {
              h1 {
                  font-size: 35px;
              }
          }

          @media (min-width: 150px) {
              h1 {
                  font-size: 30px;
              }
          }
      </style>

      <body class="bg-white">
          <!-- Header -->
          <nav class="bg-gradient-to-b from-gray-50 to-white sticky top-0 z-50">
              <div class="max-w-6xl mx-auto px-4 sm:px-6">
                  <div class="flex justify-center items-center h-18">
                        <div class="flex items-center space-x-2 mt-3 mb-1">
                            <img src="${logoUrl}" alt="expressapp" width="100" height="100" />
                        </div>
                  </div>
              </div>
          </nav>

          <!-- Hero Section -->
          <section class="bg-gradient-to-b from-gray-50 to-white">
              <div class="max-w-6xl mx-auto px-4 sm:px-6 py-8 lg:py-12 text-center">
                  <span class="inline-flex items-center justify-center px-3 py-1 text-sm font-medium rounded-full mb-4"
                      style="background-color: #EDEBFF; color: #4B63BF;">
                      <i data-lucide="star" class="w-3 h-3 mr-1"></i>Elevating Jewelry Sales, Digitally
                  </span>
                  <h1 class="lg:text-5xl font-bold text-gray-900 leading-tight mb-4">
                      Transform Your
                      <span class="text-transparent bg-clip-text"
                          style="background-image: linear-gradient(to right, #4B63BF, #B937A7); -webkit-background-clip: text; -webkit-text-fill-color: transparent;">
                          Jewelry Business
                      </span>
                  </h1>
                  <p class="text-md text-gray-600 max-w-2xl mx-auto mb-6">
                      ExpressApp streamlines your entire jewelry business, from procurement and inventory to sales and
                      customer relationship management.
                  </p>
                  <div class="flex flex-col sm:flex-row gap-3 justify-center mb-8">
                      <button
                          class="text-white px-6 py-3 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 flex justify-center items-center gap-2"
                          style="background-color: #4B63BF;" onmouseover="this.style.backgroundColor='#3651ba'"
                          onmouseout="this.style.backgroundColor='#4B63BF'"
                          onclick="window.parent.postMessage({type: 'redirect', url: 'https://helloapp.optigoapps.com/?cc=COMP167&ec=COMP167&newlead'}, '*')">
                          <i data-lucide="file-question" class="w-5 h-5"></i> Generate Inquiry
                      </button>
                  </div>

                  <!-- Features -->
                  <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-8" id="features"></div>

                  <!-- Benefits -->
                  <div class="bg-white rounded-2xl shadow-lg p-6 lg:p-8">
                      <h3 class="text-xl lg:text-2xl font-bold text-gray-900 text-center mb-6">Benefits</h3>
                      <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-3" id="benefits"></div>
                  </div>
              </div>
          </section>

          <!-- Footer -->
          <footer class="text-white py-5 sm:py-5.5 sticky bottom-0 z-50"
              style="background-image: linear-gradient(to right, #1e3a8a, #be185d);">
              <div class="max-w-6xl mx-auto px-2 sm:px-6 text-center">
                  <p class="text-xs">
                      Powered by <a href="https://www.example.com" target="_blank" class="text-white font-semibold">Orail
                          OptigoApps</a>
                  </p>
              </div>
          </footer>

          <script>
              lucide.createIcons();

              const features = [
                  { icon: "server-off", title: "Offline Mode Capability" },
                  { icon: "shopping-bag", title: "Real-Time Order, memo & sale" },
                  { icon: "scan-qr-code", title: "Integrated Scanning Module" },
                  { icon: "clipboard-list", title: "Cart Summary Review" },
                  { icon: "user-check", title: "Customer and Stock Management" },
                  { icon: "lock", title: "Secure Operations" },
              ];

              const featureContainer = document.getElementById("features");
              features.forEach(f => {
                  const div = document.createElement("div");
                  div.className = "border-0 shadow-md hover:shadow-lg transition-all duration-300 group py-2 text-center p-3 rounded-xl bg-white";
                  div.innerHTML = \`
                      <div class="w-10 h-10 mx-auto mb-3 text-white rounded-xl flex items-center justify-center group-hover:bg-[#6982db] transition-colors duration-300"
                          style="background-color: #5164a6;">
                          <i data-lucide="\${f.icon}" class="w-5 h-5"></i>
                      </div>
                      <h3 class="font-semibold text-gray-800 mb-1 text-sm">\${f.title}</h3>
                  \`;
                  featureContainer.appendChild(div);
              });

              const benefits = [
                  "User-Friendly & Easy to Use: Intuitive interface for salespersons.",
                  "Time-Saving: Reduces time on order taking, updates, and sending details.",
                  "Reduce manual errors and overhead.",
                  "Easy to Setup: Quick setup on any Device",
                  "Scale your business effortlessly."
              ];

              const benefitsEl = document.getElementById("benefits");
              benefits.forEach(b => {
                  const div = document.createElement("div");
                  div.className = "flex items-center gap-3 p-3 rounded-lg hover:bg-[#e3e9fa] transition-colors duration-300";
                  div.innerHTML = \`
                       <div class="w-6 h-6 rounded-full text-white flex items-center justify-center"
                            style="background-color: #5164a6;">
                        <i data-lucide="check" class="w-8 h-3"></i>
                          </div>
                      <p class="text-gray-700 text-sm leading-relaxed">\${b}</p>
                  \`;
                  benefitsEl.appendChild(div);
              });

              lucide.createIcons();
          </script>
      </body>
      </html>
    `;

    // Create a blob URL for the HTML content
    const blob = new Blob([htmlContent], { type: 'text/html' });
    const url = URL.createObjectURL(blob);

    // Set the iframe source
    if (iframeRef.current) {
      iframeRef.current.src = url;
    }

    // Cleanup function
    return () => {
      URL.revokeObjectURL(url);
      window.removeEventListener('message', handleMessage);
    };
  }, [logoUrl]);

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <iframe
        ref={iframeRef}
        title="Signup Page"
        style={{
          width: '100%',
          height: '98vh',
          border: 'none',
          overflow: 'auto'
        }}
      />
    </div>
  );
};

export default Signup;
